import { supabase } from "./supabaseClient"

// SECTION-RELATED FUNCTIONS USING SUPABASE CRUD

export async function getSections() {
  const { data, error } = await supabase
    .from('sections')
    .select('*')
    .order('created_at')
  if (error) throw new Error(error.message)
  return data
}

export async function addSection(sectionData) {
  const { data, error } = await supabase
    .from('sections')
    .insert(sectionData)
    .select('*').single()
  if (error) throw new Error(error.message)
  return data
}

export async function updateSection(id, updatedData) {
  const { data, error } = await supabase
    .from('sections')
    .update(updatedData)
    .eq('id', id)
    .select('*').single()
  if (error) throw new Error(error.message)
  return data
}

export async function deleteSection(id) {
  const { data: items, error: fetchError } = await supabase
  .from('menu_items')
  .select('id')
  .eq('section_id', id)
  .limit(1); // Limit to 1 for efficiency

  if (fetchError) throw fetchError;

  if (items.length > 0) {
    alert('Cannot delete section: delete all items first.');
    return;
    }

  const { data, error } = await supabase
    .from('sections')
    .delete()
    .eq('id', id)
  if (error) throw new Error(error.message)
  return data
}

// MENU ITEM FUNCTIONS WITH SECTION SUPPORT USING SUPABASE CRUD

export async function getMenuItems() {
  const { data, error } = await supabase
    .from('menu_items')
    .select(`
      id,
      name,
      description,
      name_arabic,
      description_arabic,
      price,
      image_url,
      created_at,
      section_id
    `)
    .order('created_at', { ascending: true })
  if (error) throw new Error(error.message)
  return data
}

export async function addMenuItem(item) {
  // Validate required field
  if (!item.section_id) {
    throw new Error('Section ID is required')
  }
  const { data, error } = await supabase
    .from('menu_items')
    .insert({
      ...item,
      price: parseFloat(item.price)
    }).select('*').single()
    
  if (error) throw new Error(error.message)
  return data
}

export async function editMenuItem(id, updatedItem) {
  const { data, error } = await supabase
    .from('menu_items')
    .update({
      ...updatedItem,
      price: parseFloat(updatedItem.price)
    })
    .eq('id', id)
    .select('*').single()
  if (error) throw new Error(error.message)
  return data
}

export async function deleteMenuItem(id) {
  const { data: menuItemData, error: fetchError } = await supabase
    .from('menu_items')
    .select('image_url')
    .eq('id', id)
    .single();

  if (fetchError) throw new Error(fetchError.message);

  if (menuItemData?.image_url) {
    const fullUrl = menuItemData.image_url;
    const item_image = fullUrl.split("/menu-images/")[1];
    
    const { error: deletionError } = await supabase.storage
      .from('menu-images')
      .remove([item_image]);

    if (deletionError) throw new Error(deletionError.message);
  }

  const { data, error: deleteError } = await supabase
    .from('menu_items')
    .delete()
    .eq('id', id);

  if (deleteError) throw new Error(deleteError.message);

  return data;
}

// const fetchMenuItemFromDB = async (menuItemId) => {
//   const { data, error } = await supabase
//     .from('menu_items')
//     .select('*')
//     .eq('id', menuItemId)
//     .single();
//   if (error) {
//     console.error("Error fetching menu item from DB:", error);
//     return null;
//   }
//   return data;
// };

export const uploadImageAndUpdateMenuItem = async (imageFile, menuItem) => {
  if (!imageFile) return null;
  
  const { data, error } = await supabase.storage
    .from('menu-images')
    .upload(`menu-item-${menuItem.id}-${Date.now()}`, imageFile);

  if (error) {
    console.error('Image upload error:', error);
    return null;
  }

  const { data: publicUrlData } = await supabase
    .storage
    .from('menu-images')
    .getPublicUrl(data.path);

  const imageUrl = publicUrlData.publicUrl;

  const { error: updateError } = await supabase
    .from('menu_items')
    .update({ image_url: imageUrl })
    .eq('id', menuItem.id);

  if (updateError) {
    console.error('Error updating menu item:', updateError);
  }
  return imageUrl;
};

// AUTHENTICATION USING SUPABASE AUTH

// Note: Supabase Auth typically requires an email along with a password,
// so you may need to update your UI accordingly.
export async function login(email, password) {
  const { user, session, error } = await supabase.auth.signIn({ email, password })
  if (error) throw new Error(error.message)
  return { user, session }
}
